import { ReactNode } from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button, { Props as ButtonProps } from 'components/button/Button';

interface LoginasModalSubmitButtonProps
  extends Omit<ButtonProps, 'children' | 'type'> {
  children?: ReactNode;
}

const LoginasModalSubmitButton = ({
  children,
  disabled,
  ...props
}: LoginasModalSubmitButtonProps) => {
  const { t } = useTranslation();
  const { isDirty, isSubmitting } = useFormState();

  return (
    <Button
      bsStyle="primary"
      data-testid="modal-form-submit-button"
      disabled={!isDirty || (disabled ?? isSubmitting)}
      type="submit"
      {...props}
    >
      {children ??
        t(
          isSubmitting
            ? 'common.loginas.LoginAsModalSubmitButtonLoading'
            : 'common.loginas.LoginAsModalSubmitButton',
        )}
    </Button>
  );
};

LoginasModalSubmitButton.defaultProps = {
  children: undefined,
};

export default LoginasModalSubmitButton;
